import Text from '@modules/common/components/text';

const ErrorMessage = ({
  error,
  'data-testid': dataTestid,
}: {
  error?: string | null;
  'data-testid'?: string;
}) => {
  if (!error) {
    return null;
  }

  return (
    <Text
      as="div"
      variant="small-regular"
      className="pt-2 text-rose-500"
      data-testid={dataTestid}
    >
      <span>{error}</span>
    </Text>
  );
};

export default ErrorMessage;
